module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    class: _vm.className,
    attrs: {
      "id": "layout"
    }
  }, [_c('div', {
    staticClass: "wrapper centered",
    class: {
      'nav-open': _vm.navOpened
    }
  }, [_c('sidebar', {
    attrs: {
      "open": _vm.navOpened
    }
  }), _c('div', {
    staticClass: "main-panel",
    class: {
      'loading': _vm.loading
    }
  }, [_c('ed-meta-nav'), _c('navigation', {
    on: {
      "toggleSideBar": _vm.toggleSideBar
    }
  }), _vm._t("default"), _c('md-footer'), (_vm.navOpened) ? _c('div', {
    staticClass: "close-layer",
    on: {
      "click": _vm.onCloseLayerClick
    }
  }) : _vm._e()], 2)], 1)])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-7e14003b","hasScoped":false}!./~/vue-loader/lib/template-compiler/preprocessor.js?engine=pug!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/Layouts/other.vue
// module id = v40H
// module chunks = 13 14